(function () {
  class DynamicRecs extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
      this._loaded = false; // prevent double load
    }

    connectedCallback() {
      if (this._loaded) return;

      this._observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this._observer.disconnect();
          this._loadContent();
        },
        { rootMargin: "0px 0px 300px 0px" }
      );

      this._observer.observe(this);
    }

    async _loadContent() {
      if (this._loaded) return;

      const url = this.dataset.url;
      if (!url) return;

      try {
        const res = await fetch(url);
        const html = await res.text();

        const temp = document.createElement("div");
        temp.innerHTML = html;

        // ONLY select this (prevents nesting bug)
        const incoming = temp.querySelector("complementary-products");

        if (!incoming || !incoming.innerHTML.trim()) {
          this.innerHTML = "";
          return;
        }

        // EXTRA SAFETY: prevent recursive injection
        if (incoming.querySelector("dynamic-recs")) {
          console.warn("Recursive dynamic-recs prevented");
          return;
        }

        // Inject ONLY inner content
        this.innerHTML = incoming.innerHTML;

        this._loaded = true;
        this.classList.add("recs-loaded");

        // Re-init slider
        if (window.initOwlCarousel) {
          window.initOwlCarousel(this);
        }

        // Re-init FBT
        if (window.initFBT) {
          this.querySelectorAll("[data-section-id]").forEach((el) => {
            window.initFBT(el.dataset.sectionId);
          });
        }

      } catch (err) {
        console.warn("Recommendations load failed:", err);
      }
    }
  }

  customElements.define("dynamic-recs", DynamicRecs);



  // Reload after cart updates
  window.reloadDynamicRecs = async function () {
    const blocks = document.querySelectorAll("dynamic-recs");

    for (const block of blocks) {
      const url = block.dataset.url;
      if (!url) continue;

      try {
        const res = await fetch(url);
        const html = await res.text();

        const temp = document.createElement("div");
        temp.innerHTML = html;

        const incoming = temp.querySelector("complementary-products");

        if (!incoming || !incoming.innerHTML.trim()) continue;

        // prevent recursion again
        if (incoming.querySelector("dynamic-recs")) continue;

        block.innerHTML = incoming.innerHTML;

        if (window.initOwlCarousel) {
          window.initOwlCarousel(block);
        }

      } catch (e) {
        console.error("Reload failed:", e);
      }
    }
  };



  // Auto-refresh when cart updates
  (() => {
    const nativeFetch = window.fetch;

    window.fetch = async function (...args) {
      const res = await nativeFetch(...args);

      const url = args[0];

      if (
        typeof url === "string" &&
        /\/cart\/(add|change|update|clear)/.test(url)
      ) {
        setTimeout(() => {
          if (window.reloadDynamicRecs) {
            window.reloadDynamicRecs();
          }
        }, 300);
      }

      return res;
    };
  })();
})();